// DATA RECEIVED FROM API

// GENERAL CASE : ARRAY OR SINGLE OBJECT
export const afterReceiving = (data: any) => {
  if (data && Array.isArray(data)) {
    data = data.map((object: any) => afterReceivingOne(object))
  }
  else if (data.docs && data.count && Array.isArray(data.docs)) {
    data.docs = data.docs.map((object: any) => afterReceivingOne(object))
  }
  else if (typeof data === 'object') {
    data = afterReceivingOne(data)
  }
  return data
}

const afterReceivingOneEvent = (event: any) => ({
  ...event,
  start: event.start && new Date(event.start),
  end: event.end && new Date(event.end),
  stamp: event.stamp && new Date(event.stamp),
  attendees: event.attendees?.map((attendee: any) => ({
    ...attendee,
    sentDate: attendee.sentDate && new Date(attendee.sentDate),
    statusChangeDate: attendee.statusChangeDate && new Date(attendee.statusChangeDate),
    manualStatusChangeDate: attendee.manualStatusChangeDate && new Date(attendee.manualStatusChangeDate),
  })),
})

// SINGLE OBJECT
const afterReceivingOne = (object: any) => {
  if (typeof object === 'object') {
    let events = object.events
    if (events) {
      events = Array.isArray(events)
        ? events.map(afterReceivingOneEvent)
        : afterReceivingOneEvent(events)
    }

    return {
      ...object,
      _created: object._created && new Date(object._created),
      events,
      sentDate: object.sentDate?.map((d: any) => d && new Date(d)),
    }
  }
  return object
}

// DATA SENT TO API

const beforeSendingOneEvent = (event: any) => ({
  ...event,
  start: event.start instanceof Date ? event.start.toISOString() : event.start,
  end: event.end instanceof Date ? event.end.toISOString() : event.end,
})

export const beforeSending = (data: any) => {
  if (typeof data !== 'object' || !data) return data

  let events = data.events
  if (events) {
    events = Array.isArray(events)
      ? events.map(beforeSendingOneEvent)
      : beforeSendingOneEvent(events)
  }

  return {
    ...data,
    events,
  }
}
